module.exports = __webpack_public_path__ + "static/media/youtube.18df9696.svg";